import contentSettings from '@site/content.settings'

import { runWhenCookiebotConsentGranted } from '~/app/cookiebot'

const ECOMAIL_CONSENT_CATEGORIES = ['marketing']

function initEcomail(app) {
  if (window.__ecomailInitialized) return
  window.__ecomailInitialized = true
  ;(function(p, l, o, w, i, n, g) {
    if (!p[i]) {
      p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []
      p.GlobalSnowplowNamespace.push(i)
      p[i] = function() {
        ;(p[i].q = p[i].q || []).push(arguments)
      }
      p[i].q = p[i].q || []
      n = l.createElement(o)
      g = l.getElementsByTagName(o)[0]
      n.async = 1
      n.src = 'https://d70shl7vidtft.cloudfront.net/ecmtr-2.4.2.js'
      g.parentNode.insertBefore(n, g)
    }
  })(window, document, 'script', '', 'ecotrack')

  window.ecotrack('newTracker', 'cf', 'd2dpiwfhf3tz0r.cloudfront.net', {
    appId: 'cvb',
    consentModeV2: true,
  })
  window.ecotrack('setUserIdFromLocation', 'ecmid')

  window.ecotrack('trackPageView')

  if (app.router) {
    app.router.afterEach(() => {
      if (typeof window.ecotrack === 'function') {
        window.ecotrack('trackPageView')
      }
    })
  }
}

export default ({ app }) => {
  if (process.server) return

  runWhenCookiebotConsentGranted(contentSettings, ECOMAIL_CONSENT_CATEGORIES, () => {
    initEcomail(app)
  })
}
